var pu = null;

$(document).ready(function(){
  $('#pop').once('sw_pu').each(function() {
    pu = new Popup($(this));
  });
});

var Popup = function ( $pop ) {
  var _this = this;

  this.$pop = $pop;
  this.$wrap = this.$pop.find('.pop-wrap');
  this.$close = this.$pop.find('.pop-close');
  this.$overlay = this.$pop.find('.pop-overlay');
  this.$content = this.$pop.find('.pop-content');
  this.$pad = this.$pop.find('.pop-pad');
  this.$prev = this.$pop.find('.pop-prev');
  this.$next = this.$pop.find('.pop-next');

  this.$detached_content = null;
  this.$detached_from = null;

  this.$close.on('click', function () {
    _this.close();
  });
  this.$overlay.on('click', function () {
    _this.close();
  });
  this.$pop.on('click', function (e) {
    if ( !$(e.target).closest('.pop-wrap').length && !$(e.target).is('.pop-wrap')) {
      _this.close();
    }
  });

  $(document).on('click', 'a.js-pop-open-inline', function(e) {
    e.preventDefault();
    var id = $(this).attr('href');
    var $cont = $(id);
    if ( $cont.length ) {
      if ( $cont.hasClass('js-pop-clone')) {
        var $html = $cont.children().clone(true);
        $html.find('.js-lazy.js-lazy-wait').not('.js-lazy-loaded').removeClass('js-lazy-wait').removeClass('js-lazy-processed');
        _this.open($html, $(this));
      } else {
        _this.$detached_content = $cont.children().detach();
        _this.$detached_from = $cont;
        _this.open(_this.$detached_content, $(this));
      }
      return false;
    }
  });

  $(document).on('click', '.js-pop-open', function(e) {
    e.preventDefault();
    var url = $(this).data('url');
    if ( url ) {
      _this.open_ajax ( url );
    }
  });

  $(document).on('click', '.js-pop-open-image', function(e) {
    e.preventDefault();
    const $a = $(this);
    var url = $a.attr('href');
    var w = $a.data('width');
    var h = $a.data('height');
    var g = $a.data('gallery');
    var tl = $a.data('text-left');
    var tr = $a.data('text-right');
    var gi = 0;
    if ( g ) {
      var $ga = _this.gallery_links(g);
      var gi = $ga.index(this);
    }
    if ( url ) {
      _this.open_image ( url, w, h, g, gi, tl, tr );
    }
  });

  $(document).on('click', '.js-pop-ga', function(e) {
    const $a = $(this);
    const g = $a.data('gallery');
    const i = $a.data('index');
    const $links = _this.gallery_links(g);
    const $a2 = $links.eq(i);
    $a2.trigger('click');
  });

  $(document).on('click', '.js-pop-video', function(e) {
    e.preventDefault();
    var $a = $(this);
    var url = $a.attr('href');
    var youtube_id = $a.data('video-id');
    if ( youtube_id ) {
      _this.open_video ( url, youtube_id );
    }
  });

  this.$prev.add(this.$next).on('click', function(e) {
    e.preventDefault();
    var $a = $(this);
    var g = $a.data('gallery');
    var gi = $a.data('gallery-i');
    if ( g ) {
      var $ga = _this.gallery_links(g);
      var $a = $ga.eq(gi);
      _this.$pad.stop().animate({
        opacity: 0
      },{
        duration: 200,
      });
      setTimeout(function() {
        $a.trigger('click');
      },200);
    }
  });

  $(window).resize(function () {
    _this.on_resize();
  });
};

Popup.prototype.on_resize = function () {

};

Popup.prototype.gallery_links = function ( g ) {
  var $ga = $('a[data-gallery="'+g+'"]').not('.js-pop-ga');
  var $ret = null;
  $ga.each(function () {
    var $a = $(this);
    if ( !$a.closest('.slick-cloned').length && !$a.closest('#pop').length ) {
      if ( $ret ) {
        $ret = $ret.add($a);
      } else {
        $ret = $a;
      }
    }
  });
  return $ret;
};

Popup.prototype.open_video = function ( url, youtube_id ) {
  var iframe_src = 'https://www.youtube.com/embed/'+youtube_id+'?autoplay=1&rel=0&controls=1&showinfo=1&modestbranding=1&enablejsapi=0&iv_load_policy=3';
  var content = '<div class="yt-video-wrap">' +
    '<iframe src="'+iframe_src+'" frameborder="0" allowfullscreen allow="autoplay"></iframe>' +
    '</div>';
  this.open(content, 'pop-video' );
};

Popup.prototype.open_image = function ( scr, w, h, g, gi, tl, tr ) {
  var prev = null;
  var next = null;
  if ( g ) {
    var $ga = this.gallery_links ( g );
    if ( $ga.length > 1 ) {
      var prev = gi > 0 ? gi - 1 : $ga.length - 1;
      var next = gi < $ga.length - 1 ? gi + 1 : 0;
      var $prev = $ga.eq ( prev );
      var $next = $ga.eq ( next );
    }
  }
  var content = '<div class="image-wrap image-wrap--contain">' +
    '<img class="" src="'+scr+'" width="'+w+'" height="'+h+'">';
  if ( tl||tr ) {
    content += '<div class="pop-image-text">';
    if ( tl ) {
      content += '<div class="pop-image-text-left">'+tl+'</div>';
    }
    if ( tr ) {
      content += '<div class="pop-image-text-right">'+tr+'</div>';
    }
    content += '</div>';
  }
  if ( next !== null ) {
    content += '<a class="js-pop-ga next full" data-gallery="' + g + '" data-index="' + next + '"></a>';
  }
  content += '</div>';
  if ( prev !== null || next !== null ) {
    content += '<a class="js-pop-ga prev" data-gallery="'+g+'" data-index="'+prev+'"></a>';
    content += '<a class="js-pop-ga next" data-gallery="'+g+'" data-index="'+next+'"></a>';
  }
  this.aspect_ratio = w/h;
  this.max_height = h;
  this.open(content,'pop-image');
};

Popup.prototype.open_ajax = function ( url ) {
  var _this = this;

  this.$pop.find('.wait').remove();
  this.$pop.append(wait());
  this.$pop.fadeIn(300);
  this.$pop.attr('class', '');
  this.$pop.addClass('pop-wait');
  this.on_resize();

  this.ajax = $.ajax({
    url: url,
    method: 'GET',
    cache: false,
    dataType: 'html',
    success: function ( resp ) {
      _this.$pop.find('.wait').fadeOut(300, function () {
        $(this).remove();
      });
      if ( $(resp).find('.js-pop-modal-content').length ) {
        resp = $(resp).find('.js-pop-modal-content');
      }
      _this.open ( resp, 'pop-ajax' );
    },
    error: function ( xhr, status, error ) {
      alert ( 'AJAX error! ' + status + ', ' + error );
      _this.$pop.find('.wait').remove();
    }
  });
};

Popup.prototype.open = function ( content, className ) {
  var _this = this;

  // var g = $a.data('gallery');
  // if ( g ) {
  //   var $ga = this.gallery_links(g);
  //   if ( $ga.length === 1 ) {
  //     g = null;
  //   } else {
  //     var gi = $ga.index($a[0]);
  //     var prev = gi > 0 ? gi - 1 : $ga.length - 1;
  //     var next = gi < $ga.length - 1 ? gi + 1 : 0;
  //     this.$prev.data('gallery',g).data('gallery-i',prev).show();
  //     this.$next.data('gallery',g).data('gallery-i',next).show();
  //   }
  // }
  // if ( !g ) {
  //   this.$prev.hide();
  //   this.$next.hide();
  // }

  this.$pad.html('');
  if ( content instanceof jQuery ) {
    this.$pad.append(content);
  } else {
    this.$pad.html(content);
  }

  _this.$pop.attr('class', '');
  if ( className ) {
    _this.$pop.addClass(className);
  }

  setTimeout(function() {
    _this.$pop.addClass('open');
    $('body').trigger('pop-open');
  },10);
  this.$pop.fadeIn(300);
  this.$pad.stop().animate({
    opacity: 1
  },{
    duration: 200,
  });

  setTimeout(function() {
    $(window).resize();
  }, 0 );
  //_this.on_resize();
};

Popup.prototype.close = function () {
  this.aspect_ratio = null;
  this.max_height = null;
  var _this = this;
  var $detached = _this.$detached_content;
  this.$pop.removeClass('open');
  this.$pop.fadeOut(300, function() {
    if ( _this.$detached_content ) {
      _this.$detached_content.css({opacity:0});
      _this.$detached_from.append(_this.$detached_content);
      _this.$detached_content = null;
      _this.$detached_from = null;
    }
    _this.$pad.html('');
    setTimeout(function() {
      $(window).resize();
      if ( $detached ) {
        setTimeout(function() {
          $detached.animate({opacity: 1},{duration:200});
        }, 100);
      }
    }, 0 );
  });
};
